import React, { useState } from 'react'
import { Wrapper } from '@googlemaps/react-wrapper'
import { MapGoogle, MAP_LIBRARIES, RecaptchaNotice } from '../../components'
import { AlertDialog } from '../../components/AlertDialog'
import { detectInAppBrowser, locationSettingsHint } from '../../utils'
import {
  MapRoot,
  HeaderCard,
  Title,
  FooterContainer,
  TextParragraph,
  FooterHint,
} from '../MapPage/styles'

const expiredTitle = 'La conexión ha caducado o la url es incorrecta'
const expiredSubtitle = 'por favor solicita una nueva'

// Mismo diseño del mapa principal: quien recibe el enlace ve la moto y su propia ubicación.
function SharedMap({
  view,
  position,
  authorization,
  selectedVehicleData,
  onCloseAlert,
  openAlert,
  userLocation,
  locationError,
  vehicleLabel,
  onRecenterVehicle,
  onLocateUser,
  followVehicleKey,
}) {
  const [locationHelpClosed, setLocationHelpClosed] = useState(false)
  // Dentro de otra app (Discord, WhatsApp…) la salida es abrir Chrome: ese aviso manda.
  const [inAppBrowser] = useState(() => Boolean(detectInAppBrowser()))

  const footerHint = () => {
    if (!vehicleLabel) return 'Cargando la ubicación de la moto…'
    if (locationError) return 'Activa tu ubicación para verte en el mapa'
    return 'Ubicación compartida en tiempo real'
  }

  return (
    <MapRoot>
      <AlertDialog
        mainbuttonTitle="Entendido"
        selectedVehicleData={{}}
        openAlert={Boolean(authorization && locationError) && !locationHelpClosed && !inAppBrowser}
        handleAceptAlert={() => setLocationHelpClosed(true)}
        handleCloseAlert={() => setLocationHelpClosed(true)}
        title="Activa tu ubicación"
        subtitle={`Así te vemos en el mapa junto a la moto. ${locationSettingsHint()}`}
      />
      <HeaderCard>
        <Title>TRAKKU</Title>
      </HeaderCard>
      {authorization ? (
        <Wrapper
          apiKey="AIzaSyAINQfRs6ACIur8xjLP8pCIXrZFIoJh39o"
          version="weekly"
          libraries={MAP_LIBRARIES}
        >
          <MapGoogle
            view={view}
            vehicles={position}
            userLocation={userLocation}
            selectedVehicleData={selectedVehicleData}
            showLocationAlert={false}
            onRecenter={onRecenterVehicle}
            recenterLabel="Centrar la moto"
            recenterImage={selectedVehicleData?.[0]?.img}
            onLocateUser={onLocateUser}
            followVehicleKey={followVehicleKey}
          />
        </Wrapper>
      ) : (
        <AlertDialog
          selectedVehicleData
          openAlert={openAlert}
          handleCloseAlert={onCloseAlert}
          handleAceptAlert={onCloseAlert}
          handleCancelAlert={onCloseAlert}
          title={expiredTitle}
          subtitle={expiredSubtitle}
          mainbuttonTitle="Cerrar"
        />
      )}
      <FooterContainer>
        {vehicleLabel ? <TextParragraph>{vehicleLabel}</TextParragraph> : null}
        <FooterHint>{footerHint()}</FooterHint>
        <RecaptchaNotice compact />
      </FooterContainer>
    </MapRoot>
  )
}

export default SharedMap
